import React from "react";
import ChangePasswordForm from "../components/forms/ChangePasswordForm";
import { Container, Row, Col } from "react-bootstrap";
import Footer from "../components/Footer";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var ChangePassword = function ChangePassword() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 5,
          children: /*#__PURE__*/_jsx("div", {
            className: "white-bg cool-radius",
            children: /*#__PURE__*/_jsx(ChangePasswordForm, {})
          })
        })
      })
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
};
export default ChangePassword;